import PropTypes from 'prop-types';
import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import {concat, difference, every, find, filter, flatMap, flattenDeep, get, includes, join, map, uniq, uniqBy, union, cloneDeep, isArray, remove, isEqual, unset, sortBy, size, groupBy, trim, toLower, pick} from 'lodash';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import {I18n} from 'react-redux-i18n';
import { TextField } from '@material-ui/core';
import { InputAdornment } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
import SearchIcon from "@material-ui/icons/Search";

export default class MultipleSelectFilter extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.arrayOf(PropTypes.string),
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      children: PropTypes.arrayOf(PropTypes.shape({}))
    })),
    showList: PropTypes.bool,
    searchText: PropTypes.string
  }

  static defaultProps = {
    value: [],
    options: [],
    isMobile: true,
    showList: false,
    searchText: ''
  }

  constructor(props) {
    super(props);
    const {value, options, searchText} = props;

    this.state = {
      selected: [...value],
      leveredOptions: this.getAvailableOptions(options),
      listOptions: options,
      searchText: searchText
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if(!isEqual(nextProps.value, prevState.value)){
      return {
        value: nextProps.value
      }
    }
    return null;
  }
  componentDidUpdate(props){
    if(this.props.searchText != this.state.searchText){
      this.setState({searchText: this.props.searchText}, () => {
        this.filterResults(this.state.searchText);
      })
    }
  }
  componentDidMount() {
    this.updateSelectedList(this.props);
  }
  updateSelectedList = (nextProps) => {
    const value = nextProps.value;
    let selectedValues = [];
    for (let i = 0; i < value.length; i++) {
      if ((filter(this.state.leveredOptions, {id: value[i]})).length > 0) {
        selectedValues.push(value[i]);
      }
    }

    const withChildrenSelected = this.getRootWhereAllChildrenAreSelected(selectedValues);
    selectedValues = concat(selectedValues, withChildrenSelected);
    this.setState({selected: uniq(selectedValues), leveredOptions: this.getAvailableOptions(nextProps.options)});
  }
  /**
   * Method to filter the options list based on the search string
   * Once the results are filtered, check whether parent already present. If exists, then we will not show the item in the flat list inorder to show them in hierarchy
   * Also if the filtered results doesn't contain the parent group then we will get and assign parentGroupName to be used to show them in the label display in renderOption method.
   * @param {*} str 
   */
  filterResults = (str) => {
    let updatedList = cloneDeep(this.props.options);
    const listItems = cloneDeep(this.state.leveredOptions);
    if(str != ''){
      const opts = [...this.state.leveredOptions];
      if(opts && opts.length > 0){
        updatedList = opts.filter(item => item.name.toLowerCase().indexOf(str.toLowerCase()) > -1 );
      }
      const parentGroups = filter(updatedList, item => !item.parentGroupId || item.parentGroupId === undefined) || [];
      updatedList = filter(updatedList, item => {
        if(!find(parentGroups, {id: `root${item.parentGroupId}`})){
          const parentGroup = find(listItems, {id: `root${item.parentGroupId}`});
          if(parentGroup){
            item.parentGroupName = parentGroup.name;
          }
          return item;
        }
      });
    }
    this.setState({listOptions: updatedList});
  }

  getOptionById = id => {
    return find(this.state.leveredOptions, {id});
  }

  getAvailableOptions = options => {
    const levelOptions = op => {
      return flatMap(op, option => {
        const {id, name, root, children, selectedLabel, parentGroupId} = option;
        return concat({id, name, root, children, selectedLabel, parentGroupId}, levelOptions(get(option, 'children')));
      });
    };

    // flat map with all options
    return levelOptions(options);
  }

  getRootWhereAllChildrenAreSelected = values => {
    return flatMap(this.state.leveredOptions, it => {
      if (it.root && !includes(values, it.id)) {
        if (every(get(it, 'children', []), child => includes(values, child.id))) {
          return [it.id];
        }
      }
      return [];
    });
  }
  handleTextSearch = event => {
    let value = get(event, 'target.value');
  }
  handleChange = event => {
    let values = get(event, 'target.value');
    if(!values) return;
    if(!isArray(values) && this.props.showList == true){
      const valueIndex = this.state.selected.indexOf(values);
      if(valueIndex !== -1){
        const prevSelectedVals = [...this.state.selected];
        prevSelectedVals.splice(valueIndex, 1);
        values = [...prevSelectedVals];
      } else {
        values = [...this.state.selected, values];
      }
    }
    const deselect = difference(this.state.selected, values);

    const getChildrenIds = (option, includeRoots) => map(get(option, 'children', []), it => {
      if (includeRoots || !it.root) {
        return union([it.id], getChildrenIds(it));
      }
      return union([], getChildrenIds(it));
    });
    const toRemove = flattenDeep(map(deselect, value => {
      const selected = this.getOptionById(value);
      if (selected.root) {
        return getChildrenIds(selected);
      }
      return value;
    }));

    const getRootWithUnselectedChild = option => {
      const populatedOption = this.getOptionById(option);
      return map(get(populatedOption, 'children', []), child => {
        if (includes(toRemove, child.id)) {
          return option;
        }
        return map(get(child, 'children', []), getRootWithUnselectedChild);
      });
    };

    const rootsToRemove = flattenDeep(map(this.state.selected, getRootWithUnselectedChild));
    values = filter(values, it => !includes(toRemove, it) && !includes(rootsToRemove, it));
    values = concat(values, this.getRootWhereAllChildrenAreSelected(values));

    let selected = uniqBy(flattenDeep(map(values, op => {
      const option = find(this.state.leveredOptions, {id: op});
      const children = ch => map(get(ch, 'children', []), it => concat([it], children(it)));
      return concat([option], children(option));
    })), 'id');


    values = uniq(flattenDeep(map(selected, op => {
      if (op.root) {
        return getChildrenIds(op);
      }
      return op.id;
    })));

    selected = map(selected, it => it.id);
    this.setState({selected: selected});
    this.props.onChange(values);
  }

  renderValue = value => {
    const getSelectedValue = id => {
      const selected = find(this.state.leveredOptions, op => op.id === id);
      if (selected.root) {
        return [];
      }
      return get(selected, 'selectedLabel', get(selected, 'name'));
    };
    return this.props.label;
  }
  getSelectedVals = () => {
    return this.state.selected;
  }
  renderOption = (option, paddingLeft = 0, checked) => {
    const isChecked = checked || includes(this.getSelectedVals(), option.id);
    let options = [];
    options = (
        <li
          key={option.id}
          value={option.id}
          style={{paddingLeft: `${paddingLeft}px`}}
        >
          {/* TODO: remove checkbox when rendering selected values */}
          <Checkbox checked={isChecked} id={"btnCheckbox_" + option.id} value={this.props.showList ? option.id : ''} onChange={this.handleChange}/>
          {/* If the filtered results doesnt contain the parent, then need to show the parent group name along with the name. During filteresults we will assign the parentGroupName and use it here for display*/}
          {this.state.searchText === '' ? option.name : (option.parentGroupName ? `${option.name} (${option.parentGroupName})` : option.name)}
        </li>
    );

    const children = get(option, 'children', []);
    options = concat(options,
      map(children, child => this.renderOption(child, paddingLeft + 20, isChecked)));
      
    return options;
  }

  renderOptions = () => {
    return map(this.state.listOptions, item => this.renderOption(item));
  }

  render() {
    const {isMobile} = this.props;
    const systemId = localStorage.getItem('systemId') || '';
    const menuId = systemId === 'geotab' ? 'librarylist-filter' : '';

    return (
      !this.props.showList ? 
      <FormControl className='librarylist__formcontrol'>
        <InputLabel htmlFor="name-multiple" shrink={false}>{this.props.label}</InputLabel>
        <Select
          disableUnderline
          multiple
          label={this.props.label}
          value={this.state.selected}
          onChange={this.handleChange}
          input={<Input id={this.props.id} />}
          inputProps={{
            id: this.props.id
          }}
          renderValue={this.renderValue}
          
        >
          { this.renderOptions() }
        </Select>
      </FormControl> : <>{ this.state.listOptions && this.state.listOptions.length > 0 ? this.renderOptions() : <span className="emptyResult">{I18n.t('filter.noResult')}</span> }</>
    );
  }
}
